import { useQuery } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';

/**
 * GET /api/eraf/notification-center/channels — 채널 카탈로그 (NOTIFICATION_READ)
 * queryKey: ['notification-center', 'channels']
 */
export function useChannelCatalog() {
  return useQuery({
    queryKey: ['notification-center', 'channels'],
    queryFn: () => notificationCenterApi.channels(),
    staleTime: 5 * 60_000, // 채널 목록은 잘 변하지 않음 — 5분 캐시
  });
}
